import { z } from 'zod'

import { CouponContentDtoSchema } from '../components'

export const CouponsDtoSchema = z.array(CouponContentDtoSchema)

export type CouponsDto = z.infer<typeof CouponsDtoSchema>

export const isCouponsDto = (x: unknown): x is CouponsDto => CouponsDtoSchema.safeParse(x).success
